import { apiClient } from './client';

export const contactApi = {
    // إرسال رسالة من العميل (تعمل بنجاح)
    sendMessage: (data) => apiClient.post('/contact', data),
    
    // جلب الرسائل للوحة التحكم (تم تصحيح المسار هنا)
    getMessages: () => apiClient.get('/contact'),
    
    // حذف رسالة من لوحة التحكم (تم تصحيح المسار هنا)
    deleteMessage: (id) => apiClient.delete(`/contact/${id}`),
};
